import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

export type BadgeColor = 'default' | 'critical' | 'success' | 'warning'

const BADGE_COLORS: Record<BadgeColor, string> = {
  critical: 'bg-[#FEF4F4]',
  default: 'bg-[#E7F6FE]',
  success: 'bg-[#ECFEF2]',
  warning: 'bg-[#FFEECE]',
}

const BADGE_TEXT_COLORS: Record<BadgeColor, string> = {
  critical: '!text-red-60',
  default: '!text-blue-60',
  success: '!text-green-60',
  warning: '!text-[#C68B24]',
}

interface BadgeProps {
  text: string
  color?: BadgeColor
}

export default function Badge({ text, color = 'default' }: BadgeProps) {
  const badgeColor = BADGE_COLORS[color]
  const badgeTextColor = BADGE_TEXT_COLORS[color]

  return (
    <div
      className={clsx(
        'inline-flex px-2 py-1 justify-center items-center rounded-md',
        badgeColor
      )}
      data-testid="badge"
      data-color={color}
    >
      <Text variant="body-sm" className={badgeTextColor}>
        {text}
      </Text>
    </div>
  )
}
